/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/* ============= Footer Acordion =============  */
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const footerLinkMenu = document.querySelectorAll("button.footer__item-title");
    if (!footerLinkMenu.length) return;

    function footerToggle() {
      const content = this.nextElementSibling;
      if (!content) return;
      const isExpanded = this.getAttribute("aria-expanded") === "true";
      this.setAttribute("aria-expanded", String(!isExpanded));
      content.toggleAttribute("open", !isExpanded);
    }

    footerLinkMenu.forEach((button) => {
      button.addEventListener("click", footerToggle);
    });
  });
})();


/* ============= Custom Tab ============= */
(function () {
  function mountCTabBlockList(root) {
    if (!root || !root.querySelectorAll) return;
    var blocks = root.classList && root.classList.contains('c-tab-block')
      ? [root]
      : root.querySelectorAll('.c-tab-block');
    for (var b = 0; b < blocks.length; b++) {
      var block = blocks[b];
      var layout = block.querySelector(':scope > .c-tab-block__layout');
      if (!layout) continue;
      var list = layout.querySelector(':scope > .c-tab-block__list');
      if (!list) {
        list = document.createElement('div');
        list.className = 'c-tab-block__list';
        list.setAttribute('role', 'tablist');
        var label = layout.getAttribute('aria-label');
        if (label) list.setAttribute('aria-label', label);
        layout.insertBefore(list, layout.firstChild);
      }
      var entries = layout.querySelectorAll(':scope > .c-tab__entry');
      for (var i = 0; i < entries.length; i++) {
        var button = entries[i].querySelector(':scope > .c-tab__item');
        if (button && button.parentElement !== list) list.appendChild(button);
      }
    }
  }

  function revealTabButton(button) {
    var list = button.closest('.c-tab__list, .c-tab-block__list');
    if (!list) return;
    var listRect = list.getBoundingClientRect();
    var buttonRect = button.getBoundingClientRect();
    if (buttonRect.left < listRect.left) {
      list.scrollLeft -= listRect.left - buttonRect.left;
    } else if (buttonRect.right > listRect.right) {
      list.scrollLeft += buttonRect.right - listRect.right;
    }
  }

  function selectTabItem(button) {
    if (!button) return;
    var root = button.closest('[data-c-tab-root]');
    if (!root) return;

    var panelId = button.getAttribute('aria-controls');
    if (!panelId) return;

    var buttons = Array.prototype.slice.call(root.querySelectorAll('.c-tab__item[aria-controls]'));
    for (var i = 0; i < buttons.length; i++) {
      var isActive = buttons[i] === button;
      buttons[i].classList.toggle('is-active', isActive);
      buttons[i].setAttribute('aria-selected', isActive ? 'true' : 'false');
      buttons[i].tabIndex = isActive ? 0 : -1;
    }

    var panels = root.querySelectorAll('[data-c-tab-panel]');
    for (var j = 0; j < panels.length; j++) {
      var show = panels[j].id === panelId;
      panels[j].classList.toggle('is-active', show);
      panels[j].hidden = !show;
      panels[j].toggleAttribute('hidden', !show);
    }

    window.dispatchEvent(new Event('resize'));
    root.dispatchEvent(new CustomEvent('c-tab:changed', {
      bubbles: true,
      detail: { button: button }
    }));
    revealTabButton(button);
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest('.c-tab__item[aria-controls]');
    if (!button || button.getAttribute('aria-disabled') === 'true') return;
    if (button.getAttribute('aria-selected') === 'true') return;
    selectTabItem(button);
  });

  document.addEventListener('keydown', function (e) {
    var button = e.target.closest('.c-tab__item[aria-controls]');
    if (!button) return;
    var root = button.closest('[data-c-tab-root]');
    if (!root) return;

    var buttons = Array.prototype.slice.call(root.querySelectorAll('.c-tab__item[aria-controls]'));
    var current = buttons.indexOf(button);
    if (current < 0) return;

    var next = null;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      next = (current + 1) % buttons.length;
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      next = (current - 1 + buttons.length) % buttons.length;
    } else if (e.key === 'Home') {
      next = 0;
    } else if (e.key === 'End') {
      next = buttons.length - 1;
    }
    if (next === null) return;
    e.preventDefault();
    selectTabItem(buttons[next]);
    buttons[next].focus();
  });

  document.addEventListener('shopify:block:select', function (e) {
    var target = e.target;
    if (!target || typeof target.closest !== 'function') return;
    var tabButton = target.closest('.c-tab__item[aria-controls]');
    if (tabButton) {
      selectTabItem(tabButton);
      return;
    }
    var entry = target.closest('.c-tab__entry');
    if (entry) {
      var entryButton = entry.querySelector('.c-tab__item[aria-controls]');
      if (!entryButton) {
        var entryPanel = entry.querySelector('[data-c-tab-panel]');
        var entryRoot = entry.closest('[data-c-tab-root]');
        if (entryPanel && entryPanel.id && entryRoot) {
          entryButton = entryRoot.querySelector('.c-tab__item[aria-controls="' + entryPanel.id + '"]');
        }
      }
      if (entryButton) {
        selectTabItem(entryButton);
        return;
      }
    }
    var panel = target.closest('[data-c-tab-panel]');
    if (!panel || !panel.id) return;
    var root = panel.closest('[data-c-tab-root]');
    if (!root) return;
    var button = root.querySelector('.c-tab__item[aria-controls="' + panel.id + '"]');
    if (button) selectTabItem(button);
  });

  function initTabRoots(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    mountCTabBlockList(context);
    var roots = context.classList && context.hasAttribute && context.hasAttribute('data-c-tab-root')
      ? [context]
      : context.querySelectorAll('[data-c-tab-root]');
    roots.forEach(function (root) {
      var active = root.querySelector('.c-tab__item[aria-selected="true"], .c-tab__item.is-active');
      if (!active) {
        active = root.querySelector('.c-tab__item[aria-controls]');
      }
      if (active) selectTabItem(active);
    });
  }

  initTabRoots(document);

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initTabRoots(e.target);
  });
})();


/* ============= Swiper: data-swiper-autoinit（商品リスト等・セクション共通） ============= */
/*
 * Liquid 側で data-swiper-autoinit を付けた .swiper 要素を自動初期化する。
 * 主な data 属性:
 *   - data-swiper-column-mobile / -tablet / -pc … ブレークポイント別の表示カラム数
 *   - data-swiper-gap-mobile / -tablet / -pc … ブレークポイント別のスライド間隔
 *   - data-swiper-gap … 上記が未指定のときの共通フォールバック
 *   - data-swiper-centered-mobile / -tablet / -pc … "true"|"false"（BP 別の中央寄せ）
 *   - data-swiper-allow-touch-mobile / -tablet / -pc … "true"|"false"（BP 別のスワイプ可否）
 *   - data-swiper-speed … スライド切替速度（ms）。未指定時は Swiper デフォルト
 *   - data-swiper-desktop-only="true" … 741px 以上のみ Swiper 初期化（SP は CSS 横スクロール。styles は custom.css 共通）
 *   - data-swiper-pagination="true" … ページネーション有効化（.swiper 内、または親ナビルート内）
 *   - data-swiper-navigation="true" … 前後ナビ有効化
 *   - data-swiper-nav-root … ナビ探索の親セレクタ（例: .c-coordinate-list）。未指定時は .c-swiper-container
 *   - data-swiper-quick-buy-reparent="true" … クイック購入 UI を body へ移動（overflow 対策）
 *   - data-swiper-rows-mobile … スマホのみ縦に並べる行数（例: 2）。未指定時は 1。タブレット以上は常に 1
 */
(function () {
  var SELECTOR = '[data-swiper-autoinit]';
  var DESKTOP_MQ = '(min-width: 741px)';
  /** @type {Map<HTMLElement, Swiper>} 初期化済みインスタンス（update 時に参照） */
  var swiperMap = new Map();
  /** @type {Map<Element, {parent: Element, nextSibling: Node|null}>} クイック購入 UI の元の DOM 位置 */
  var openableOriginalParents = new Map();

  /** 文字列を数値に変換。NaN の場合は fallback を返す */
  function parseNum(v, fallback) {
    var n = parseFloat(String(v));
    return isNaN(n) ? fallback : n;
  }

  /** "true"/"false"。未指定は null */
  function parseOptionalBool(v) {
    if (v === '' || v == null) return null;
    return String(v).trim() === 'true';
  }

  /** dataset 未反映環境向けに getAttribute でも data 属性を取得 */
  function getDataAttr(el, name) {
    var v = el.getAttribute(name);
    return v === null || v === '' ? '' : String(v).trim();
  }

  function isDesktopOnly(el) {
    return getDataAttr(el, 'data-swiper-desktop-only') === 'true';
  }

  function isDesktopViewport() {
    return window.matchMedia(DESKTOP_MQ).matches;
  }

  /** .swiper 内、なければ nav-root / .c-swiper-container 内からコントロール要素を取得 */
  function findSwiperControl(swiperEl, selector) {
    var found = swiperEl.querySelector(selector);
    if (found) return found;
    var navRootSel = getDataAttr(swiperEl, 'data-swiper-nav-root');
    if (navRootSel) {
      var navRoot = swiperEl.closest(navRootSel);
      if (navRoot) {
        found = navRoot.querySelector(selector);
        if (found) return found;
      }
    }
    var root = swiperEl.closest('.c-swiper-container');
    return root ? root.querySelector(selector) : null;
  }

  /** 要素の data 属性から Swiper オプションを組み立てる */
  function buildSwiperOptions(el) {
    var desktopOnly = isDesktopOnly(el);
    var mobileStr = getDataAttr(el, 'data-swiper-column-mobile');
    var tabletStr = getDataAttr(el, 'data-swiper-column-tablet');
    var pcStr = getDataAttr(el, 'data-swiper-column-pc');
    var mobile = parseFloat(mobileStr);
    var bpTablet = parseFloat(tabletStr);
    var bpPc = parseFloat(pcStr);
    var gapFallback = parseNum(getDataAttr(el, 'data-swiper-gap'), 1);
    var spaceMbStr = getDataAttr(el, 'data-swiper-gap-mobile');
    var spaceTbStr = getDataAttr(el, 'data-swiper-gap-tablet');
    var spacePcStr = getDataAttr(el, 'data-swiper-gap-pc');
    var spaceMb = spaceMbStr !== '' ? parseNum(spaceMbStr, gapFallback) : gapFallback;
    var spaceTb = spaceTbStr !== '' ? parseNum(spaceTbStr, gapFallback) : gapFallback;
    var spacePc = spacePcStr !== '' ? parseNum(spacePcStr, gapFallback) : gapFallback;

    var centeredMb = parseOptionalBool(getDataAttr(el, 'data-swiper-centered-mobile'));
    var centeredTb = parseOptionalBool(getDataAttr(el, 'data-swiper-centered-tablet'));
    var centeredPc = parseOptionalBool(getDataAttr(el, 'data-swiper-centered-pc'));
    var touchMb = parseOptionalBool(getDataAttr(el, 'data-swiper-allow-touch-mobile'));
    var touchTb = parseOptionalBool(getDataAttr(el, 'data-swiper-allow-touch-tablet'));
    var touchPc = parseOptionalBool(getDataAttr(el, 'data-swiper-allow-touch-pc'));
    var rowsMobileStr = getDataAttr(el, 'data-swiper-rows-mobile');
    var rowsMobile = 1;
    if (rowsMobileStr !== '') {
      rowsMobile = Math.max(1, Math.round(parseNum(rowsMobileStr, 1)));
    }

    function applyCenteredTouch(target, centered, touch) {
      if (centered !== null) target.centeredSlides = centered;
      if (touch !== null) target.allowTouchMove = touch;
    }

    var options;
    if (desktopOnly) {
      // SP では初期化しない。初期表示は現在幅に合わせ、1000px 以上で PC 値へ。
      var usePc = window.matchMedia('(min-width: 1000px)').matches;
      options = {
        slidesPerView: usePc ? bpPc : bpTablet,
        spaceBetween: usePc ? spacePc : spaceTb,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          1000: {
            slidesPerView: bpPc,
            spaceBetween: spacePc
          }
        }
      };
      applyCenteredTouch(options, usePc ? centeredPc : centeredTb, usePc ? touchPc : touchTb);
      applyCenteredTouch(options.breakpoints[1000], centeredPc, touchPc);
    } else {
      options = {
        slidesPerView: mobile,
        spaceBetween: spaceMb,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          741: {
            slidesPerView: bpTablet,
            spaceBetween: spaceTb
          },
          1000: {
            slidesPerView: bpPc,
            spaceBetween: spacePc
          }
        }
      };
      applyCenteredTouch(options, centeredMb, touchMb);
      applyCenteredTouch(options.breakpoints[741], centeredTb, touchTb);
      applyCenteredTouch(options.breakpoints[1000], centeredPc, touchPc);
      // スマホのみ複数行グリッド（例: 2件縦並びで1ページ分スワイプ）
      if (rowsMobile > 1) {
        options.grid = { rows: rowsMobile, fill: 'column' };
        options.breakpoints[741].grid = { rows: 1, fill: 'column' };
        options.breakpoints[1000].grid = { rows: 1, fill: 'column' };
      }
    }

    if (getDataAttr(el, 'data-swiper-pagination') === 'true') {
      var pag = findSwiperControl(el, '.swiper-pagination');
      if (pag) {
        options.pagination = { el: pag, clickable: true };
      }
    }
    if (getDataAttr(el, 'data-swiper-navigation') === 'true') {
      var next = findSwiperControl(el, '.swiper-button-next');
      var prev = findSwiperControl(el, '.swiper-button-prev');
      if (next && prev) {
        options.navigation = { nextEl: next, prevEl: prev };
      }
    }
    var speedStr = getDataAttr(el, 'data-swiper-speed');
    if (speedStr !== '') {
      var speed = parseFloat(speedStr);
      if (!isNaN(speed)) options.speed = speed;
    }
    return options;
  }

  function destroySwiperEl(el) {
    if (!el) return;
    var sw = swiperMap.get(el);
    if (!sw && el.swiper) sw = el.swiper;
    if (sw && typeof sw.destroy === 'function') {
      sw.destroy(true, true);
    }
    swiperMap.delete(el);
  }

  /*
   * Swiper 内の overflow:hidden によりクイック購入 drawer/popover が切れるのを防ぐ。
   * open 時に body 直下へ移動し、close 時に元の位置へ戻す。
   */
  function initQuickBuyReparent(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var openables = scope.querySelectorAll('quick-buy-drawer, quick-buy-popover');
    for (var i = 0; i < openables.length; i++) {
      var openable = openables[i];
      if (openable.dataset.quickBuyReparentBound === 'true') continue;
      openable.dataset.quickBuyReparentBound = 'true';
      if (!openableOriginalParents.has(openable)) {
        openableOriginalParents.set(openable, {
          parent: openable.parentElement,
          nextSibling: openable.nextSibling
        });
      }
      var observer = new MutationObserver(function (mutations) {
        for (var m = 0; m < mutations.length; m++) {
          var mutation = mutations[m];
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            if (openable.hasAttribute('open')) {
              if (openable.parentElement !== document.body) {
                document.body.appendChild(openable);
              }
            } else {
              var original = openableOriginalParents.get(openable);
              if (original && original.parent) {
                if (original.nextSibling) {
                  original.parent.insertBefore(openable, original.nextSibling);
                } else {
                  original.parent.appendChild(openable);
                }
              }
            }
          }
        }
      });
      observer.observe(openable, { attributes: true, attributeFilter: ['open'] });
    }
  }

  function collectNodes(root) {
    if (!root || root === document || !root.nodeType || root.nodeType !== 1) {
      return document.querySelectorAll(SELECTOR);
    }
    return root.querySelectorAll(SELECTOR);
  }

  /** hidden パネル内は幅 0 で誤初期化するためスキップ（タブ表示時に再 init） */
  function isInsideHidden(el) {
    return !!(el && el.closest && el.closest('[hidden]'));
  }

  function createSwiper(el) {
    if (!el || el.classList.contains('swiper-initialized') || typeof Swiper === 'undefined') return null;
    try {
      var swiper = new Swiper(el, buildSwiperOptions(el));
      swiperMap.set(el, swiper);
      // レイアウト確定後に再計算（初回の幅計測ずれ対策）
      requestAnimationFrame(function () {
        if (swiper && typeof swiper.update === 'function') swiper.update();
      });
      return swiper;
    } catch (err) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('[custom.js] Swiper init failed', el, err);
      }
      return null;
    }
  }

  /** root 配下の未初期化 Swiper を走査して初期化する */
  function initSwipersIn(root) {
    if (typeof Swiper === 'undefined') return;
    var nodes = collectNodes(root);
    var desktop = isDesktopViewport();
    var sectionsForQuickBuy = [];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (isInsideHidden(el)) continue;
      if (isDesktopOnly(el) && !desktop) {
        destroySwiperEl(el);
        continue;
      }
      if (el.classList.contains('swiper-initialized')) continue;
      if (!createSwiper(el)) continue;
      if (el.dataset.swiperQuickBuyReparent === 'true') {
        var sec = el.closest('.shopify-section');
        if (sec && sectionsForQuickBuy.indexOf(sec) === -1) {
          sectionsForQuickBuy.push(sec);
        }
      }
    }
    for (var s = 0; s < sectionsForQuickBuy.length; s++) {
      initQuickBuyReparent(sectionsForQuickBuy[s]);
    }
  }

  /** desktop-only 要素を viewport に合わせて init / destroy */
  function syncDesktopOnlySwipers(root) {
    if (typeof Swiper === 'undefined') return;
    var nodes = collectNodes(root);
    var desktop = isDesktopViewport();
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!isDesktopOnly(el)) continue;
      if (isInsideHidden(el)) continue;
      if (desktop) {
        if (!el.classList.contains('swiper-initialized')) {
          createSwiper(el);
        } else {
          var sw = swiperMap.get(el) || el.swiper;
          if (sw && typeof sw.update === 'function') sw.update();
        }
      } else {
        destroySwiperEl(el);
      }
    }
  }

  /** swiper-bundle.min.js の defer 読み込み完了を待ってから初期化（最大約 2 秒） */
  function initSwipersDeferred(root) {
    var attempts = 0;
    var target = root || document;
    function tryInit() {
      attempts++;
      if (typeof Swiper !== 'undefined') {
        initSwipersIn(target);
        return;
      }
      if (attempts < 40) {
        setTimeout(tryInit, 50);
      }
    }
    tryInit();
  }

  /** タブ切替・テーマエディタ操作後など、スライド幅の再計算が必要なときに呼ぶ */
  function updateSwipersInRoot(root) {
    if (!root || !root.querySelectorAll) return;
    var list = root.querySelectorAll(SELECTOR);
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (isDesktopOnly(el) && !isDesktopViewport()) continue;
      var sw = swiperMap.get(el);
      if (!sw && el.swiper) sw = el.swiper;
      if (sw && typeof sw.update === 'function') {
        sw.update();
      }
    }
  }

  // Recently viewed / product recommendations: fetch 後に Swiper を初期化
  var DYNAMIC_PRODUCT_SECTION_SELECTOR = 'recently-viewed-products, product-recommendations, custom-product-cross-sell-item, category-history-products, zeta-category-ranking-products';

  function bindDynamicProductSectionSwiperInit(el) {
    if (!el || el.dataset.dynamicProductSwiperBound === 'true') return;
    el.dataset.dynamicProductSwiperBound = 'true';
    var observer = new MutationObserver(function () {
      if (el.querySelector(SELECTOR)) {
        initSwipersDeferred(el);
      }
    });
    observer.observe(el, { childList: true, subtree: true });
  }

  function bindDynamicProductSectionSwiperInitInRoot(root) {
    if (!root || !root.querySelectorAll) return;
    var nodes = root.querySelectorAll(DYNAMIC_PRODUCT_SECTION_SELECTOR);
    for (var r = 0; r < nodes.length; r++) {
      bindDynamicProductSectionSwiperInit(nodes[r]);
    }
  }

  /** スライド DOM 変更後（ランダム表示の shuffle 等）に destroy → 再 init */
  function reinitSwipersIn(root) {
    if (typeof Swiper === 'undefined') return;
    var nodes = collectNodes(root || document);
    var desktop = isDesktopViewport();
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (isInsideHidden(el)) continue;
      if (isDesktopOnly(el) && !desktop) {
        destroySwiperEl(el);
        continue;
      }
      destroySwiperEl(el);
      createSwiper(el);
    }
  }

  window.CustomSwiperAutoinit = {
    updateIn: updateSwipersInRoot,
    reinitIn: reinitSwipersIn
  };

  // 初回ページ読み込み
  document.addEventListener('DOMContentLoaded', function () {
    initSwipersDeferred();
    bindDynamicProductSectionSwiperInitInRoot(document);
  });

  // SP ⇔ PC 切替で desktop-only を同期
  window.matchMedia(DESKTOP_MQ).addEventListener('change', function () {
    syncDesktopOnlySwipers(document);
  });

  // テーマエディタでセクション追加・再読み込み時
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    if (t && t.querySelectorAll) {
      initSwipersDeferred(t);
      bindDynamicProductSectionSwiperInitInRoot(t);
    }
  });

  // テーマエディタでセクション削除時
  document.addEventListener('shopify:section:unload', function (e) {
    var t = e.target;
    if (!t || !t.querySelectorAll) return;
    var list = t.querySelectorAll(SELECTOR);
    for (var i = 0; i < list.length; i++) {
      destroySwiperEl(list[i]);
    }
  });

  // テーマエディタでセクション選択時
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target) {
      updateSwipersInRoot(e.target);
    }
  });

  // Featured Collections / Coordinate 等: タブ切替で hidden が外れたあと再計算
  document.addEventListener('tabs-nav:changed', function (e) {
    var tabsNav = e.target;
    if (!tabsNav || typeof tabsNav.closest !== 'function') return;
    var sec = tabsNav.closest('.shopify-section');
    if (!sec) return;
    setTimeout(function () {
      initSwipersIn(sec);
      updateSwipersInRoot(sec);
    }, 280);
  });

  document.addEventListener('c-tab:changed', function (e) {
    var root = e.target;
    if (!root || typeof root.closest !== 'function') return;
    var sec = root.closest('.shopify-section');
    if (!sec) return;
    setTimeout(function () {
      initSwipersIn(sec);
      updateSwipersInRoot(sec);
    }, 280);
  });

})();

/* ============= Custom Featured Collections: タブ連動ヘッダーリンク更新 ============= */
(function () {
  var SECTION_CLASS = 'shopify-section--featured-collections';
  var ACTION_ID_PREFIX = 'custom-featured-collections-header-action-';

  function getSectionInstanceId(sectionRoot) {
    if (!sectionRoot || !sectionRoot.id) return '';
    return sectionRoot.id.replace(/^shopify-section-/, '');
  }

  function syncFromSource(sourceEl, wrap) {
    if (!sourceEl || !wrap) return;
    var link = wrap.querySelector('a');
    if (!link) return;
    var text = (sourceEl.dataset.headerLinkText || '').trim();
    var url = (sourceEl.dataset.headerLinkUrl || '').trim();
    if (!text) {
      wrap.hidden = true;
      return;
    }
    wrap.hidden = false;
    link.textContent = text;
    link.href = url || '#';
  }

  function syncFeaturedCollectionSection(sectionRoot) {
    var sid = getSectionInstanceId(sectionRoot);
    if (!sid) return;
    var wrap = document.getElementById(ACTION_ID_PREFIX + sid);
    if (!wrap) return;

    var tabsNav = sectionRoot.querySelector('tabs-nav');
    var tabBorderRoot = sectionRoot.querySelector('[data-c-tab-root]');
    var sourceEl = null;

    if (tabsNav) {
      var btn = tabsNav.querySelector('.tabs-nav__item[aria-expanded="true"]');
      var panelId = btn && btn.getAttribute('aria-controls');
      sourceEl = panelId ? document.getElementById(panelId) : null;
    } else if (tabBorderRoot) {
      var borderBtn = tabBorderRoot.querySelector('.c-tab__item[aria-selected="true"]');
      var borderPanelId = borderBtn && borderBtn.getAttribute('aria-controls');
      sourceEl = borderPanelId ? document.getElementById(borderPanelId) : null;
    }
    if (!sourceEl) {
      sourceEl = sectionRoot.querySelector('[id^="block-' + sid + '-"]:not([hidden])');
    }
    syncFromSource(sourceEl, wrap);
  }

  function initAllFeaturedCollectionsHeaderLinks() {
    var nodes = document.querySelectorAll('.' + SECTION_CLASS);
    for (var i = 0; i < nodes.length; i++) {
      syncFeaturedCollectionSection(nodes[i]);
    }
  }

  document.addEventListener('tabs-nav:changed', function (e) {
    var tabsNav = e.target;
    if (!tabsNav || typeof tabsNav.closest !== 'function') return;
    var sectionRoot = tabsNav.closest('.' + SECTION_CLASS);
    if (!sectionRoot) return;
    var sid = getSectionInstanceId(sectionRoot);
    var wrap = document.getElementById(ACTION_ID_PREFIX + sid);
    if (!wrap) return;
    var button = e.detail && e.detail.button;
    var panelId = button && button.getAttribute('aria-controls');
    var panel = panelId ? document.getElementById(panelId) : null;
    if (panel) syncFromSource(panel, wrap);
  });

  document.addEventListener('c-tab:changed', function (e) {
    var tabRoot = e.target;
    if (!tabRoot || typeof tabRoot.closest !== 'function') return;
    var sectionRoot = tabRoot.closest('.' + SECTION_CLASS);
    if (!sectionRoot) return;
    var sid = getSectionInstanceId(sectionRoot);
    var wrap = document.getElementById(ACTION_ID_PREFIX + sid);
    if (!wrap) return;
    var button = e.detail && e.detail.button;
    var panelId = button && button.getAttribute('aria-controls');
    var panel = panelId ? document.getElementById(panelId) : null;
    if (panel) syncFromSource(panel, wrap);
  });

  document.addEventListener('DOMContentLoaded', initAllFeaturedCollectionsHeaderLinks);

  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains(SECTION_CLASS)) {
      syncFeaturedCollectionSection(t);
    }
  });
})();

/* ============= Custom Featured Collections: Grid「もっと見る」展開 ============= */
(function () {
  var SECTION_CLASS = 'shopify-section--featured-collections';
  var resizeTimer = null;

  function getPerRow(list) {
    var value = parseInt(getComputedStyle(list).getPropertyValue('--section-products-per-row'), 10);
    return value > 0 ? value : 1;
  }

  function getVisibleRows(list) {
    var isMobile = window.matchMedia('(max-width: 740px)').matches;
    var attr = isMobile ? list.getAttribute('data-grid-expand-rows-sp') : list.getAttribute('data-grid-expand-rows-pc');
    var rows = parseInt(attr, 10);
    return rows > 0 ? rows : 2;
  }

  function getItems(list) {
    var inner = list.querySelector('.product-list__inner');
    if (!inner) return [];
    return Array.prototype.slice.call(inner.children);
  }

  function syncGridExpandList(list) {
    if (!list || !list.hasAttribute('data-grid-expandable')) return;

    var more = list.querySelector('.product-list__more');
    var btn = list.querySelector('[data-grid-expand-button]');
    if (!btn) return;

    var items = getItems(list);
    if (!items.length) {
      if (more) {
        more.hidden = true;
        more.toggleAttribute('hidden', true);
      }
      btn.hidden = true;
      list.classList.remove('is-collapsed');
      return;
    }

    if (list.classList.contains('is-expanded')) {
      for (var i = 0; i < items.length; i++) {
        items[i].hidden = false;
        items[i].removeAttribute('hidden');
      }
      list.classList.remove('is-collapsed');
      if (more) {
        more.hidden = true;
        more.toggleAttribute('hidden', true);
      }
      btn.hidden = true;
      return;
    }

    var perRow = getPerRow(list);
    var visibleCount = perRow * getVisibleRows(list);
    var hasOverflow = items.length > visibleCount;
    list.classList.toggle('is-collapsed', hasOverflow);
    if (more) {
      more.hidden = !hasOverflow;
      more.toggleAttribute('hidden', !hasOverflow);
    }
    btn.hidden = !hasOverflow;

    for (var j = 0; j < items.length; j++) {
      var hide = hasOverflow && j >= visibleCount;
      items[j].hidden = hide;
      items[j].toggleAttribute('hidden', hide);
    }
  }

  function syncAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var lists = scope.querySelectorAll('[data-grid-expandable]');
    for (var i = 0; i < lists.length; i++) {
      syncGridExpandList(lists[i]);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-grid-expand-button]');
    if (!btn) return;
    var list = btn.closest('[data-grid-expandable]');
    if (!list) return;
    list.classList.add('is-expanded');
    list.classList.remove('is-collapsed');
    syncGridExpandList(list);
  });

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      syncAll(document);
    }, 150);
  });

  document.addEventListener('DOMContentLoaded', function () {
    syncAll(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) syncAll(e.target);
  });

  document.addEventListener('tabs-nav:changed', function (e) {
    var tabsNav = e.target;
    if (!tabsNav || typeof tabsNav.closest !== 'function') return;
    var sectionRoot = tabsNav.closest('.' + SECTION_CLASS);
    if (!sectionRoot) return;
    setTimeout(function () {
      syncAll(sectionRoot);
    }, 280);
  });

  document.addEventListener('c-tab:changed', function (e) {
    var tabRoot = e.target;
    if (!tabRoot || typeof tabRoot.closest !== 'function') return;
    var sectionRoot = tabRoot.closest('.' + SECTION_CLASS);
    if (!sectionRoot) return;
    setTimeout(function () {
      syncAll(sectionRoot);
    }, 50);
  });
})();

/* ============= Category Navigation (custom-category-navi) ============= */
(function () {
  var MOBILE_QUERY = "(max-width: 740px)";

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function setTabState(buttons, panels, activeIndex) {
    buttons.forEach(function (btn, i) {
      var active = i === activeIndex;
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-selected", active ? "true" : "false");
    });
    panels.forEach(function (panel, i) {
      var active = i === activeIndex;
      panel.classList.toggle("is-active", active);
      if (active) {
        panel.removeAttribute("hidden");
      } else {
        panel.setAttribute("hidden", "");
      }
    });
  }

  /** 指定パネル内の2・3階層をそれぞれ先頭タブに揃える */
  function activateFirstL2AndL3(panel) {
    if (!panel) return;

    var l2Buttons = panel.querySelectorAll("[data-cat-l2]");
    var l2Panels = panel.querySelectorAll("[data-cat-l2-panel]");

    if (l2Buttons.length && l2Panels.length) {
      setTabState(l2Buttons, l2Panels, 0);
    }

    var l3Scope =
      panel.querySelector("[data-cat-l2-panel].is-active") ||
      l2Panels[0] ||
      panel.querySelector("[data-cat-l3-scope]");

    if (l3Scope) {
      var l3Buttons = l3Scope.querySelectorAll("[data-cat-l3]");
      var l3Panels = l3Scope.querySelectorAll("[data-cat-l3-panel]");
      if (l3Buttons.length && l3Panels.length) {
        setTabState(l3Buttons, l3Panels, 0);
      }
    }
  }

  function getActiveL1Panel(root, l1Index) {
    var panels = root.querySelectorAll("[data-cat-panel]");
    var target = null;
    panels.forEach(function (panel) {
      if (parseInt(panel.dataset.l1Index, 10) === l1Index) {
        target = panel;
      }
    });
    return target;
  }

  function initCatNavi(root) {
    if (!root || root.dataset.catNaviInit === "true") return;
    root.dataset.catNaviInit = "true";

    var l1Buttons = root.querySelectorAll("[data-cat-l1]");
    var panels = root.querySelectorAll("[data-cat-panel]");
    var modalHeader = root.querySelector("[data-cat-modal-header]");
    var modalTitle = root.querySelector("[data-cat-modal-title]");
    var modalClose = root.querySelector("[data-cat-modal-close]");
    var overlay = root.querySelector("[data-cat-overlay]");

    var activeL1 = 0;
    var panelOpen = false;

    function hasInteractivePanels() {
      return panels.length > 0;
    }

    function openPanel(l1Index) {
      if (!hasInteractivePanels()) return;
      activeL1 = l1Index;
      panelOpen = true;

      l1Buttons.forEach(function (btn) {
        var idx = parseInt(btn.dataset.l1Index, 10);
        var active = idx === l1Index;
        btn.classList.toggle("is-active", active);
        btn.setAttribute("aria-selected", active ? "true" : "false");
        btn.setAttribute("aria-expanded", active ? "true" : "false");
      });

      panels.forEach(function (panel) {
        var panelIdx = parseInt(panel.dataset.l1Index, 10);
        var active = panelIdx === l1Index;
        panel.classList.toggle("is-active", active);
        if (active) {
          panel.removeAttribute("hidden");
        } else {
          panel.setAttribute("hidden", "");
        }
      });

      activateFirstL2AndL3(getActiveL1Panel(root, l1Index));

      if (isMobile()) {
        root.classList.add("is-modal-open");
        document.body.classList.add("cat-navi-modal-open");
        if (modalHeader) modalHeader.removeAttribute("hidden");
        if (overlay) overlay.removeAttribute("hidden");
        if (modalTitle) {
          var activeBtn = null;
          l1Buttons.forEach(function (btn) {
            if (parseInt(btn.dataset.l1Index, 10) === l1Index) activeBtn = btn;
          });
          modalTitle.textContent = activeBtn ? activeBtn.dataset.catTitle || "" : "";
        }
      } else {
        root.classList.add("is-panel-open");
      }
    }

    function closePanel() {
      panelOpen = false;
      root.classList.remove("is-panel-open", "is-modal-open");
      document.body.classList.remove("cat-navi-modal-open");
      if (modalHeader) modalHeader.setAttribute("hidden", "");
      if (overlay) overlay.setAttribute("hidden", "");

      l1Buttons.forEach(function (btn) {
        btn.classList.remove("is-active");
        btn.setAttribute("aria-selected", "false");
        btn.setAttribute("aria-expanded", "false");
      });
      panels.forEach(function (panel) {
        panel.setAttribute("hidden", "");
        panel.classList.remove("is-active");
      });
    }

    function toggleL1(l1Index) {
      if (panelOpen && activeL1 === l1Index && !isMobile()) {
        closePanel();
        return;
      }
      openPanel(l1Index);
    }

    root.addEventListener("click", function (e) {
      var l1Btn = e.target.closest("[data-cat-l1]");
      if (l1Btn) {
        e.preventDefault();
        var idx = parseInt(l1Btn.dataset.l1Index, 10);
        if (!isNaN(idx)) toggleL1(idx);
        return;
      }

      var l2Btn = e.target.closest("[data-cat-l2]");
      if (l2Btn) {
        var panel = l2Btn.closest("[data-cat-panel]");
        if (!panel) return;
        var l2Idx = parseInt(l2Btn.dataset.l2Index, 10);
        var l2Buttons = panel.querySelectorAll("[data-cat-l2]");
        var l2Panels = panel.querySelectorAll("[data-cat-l2-panel]");
        setTabState(l2Buttons, l2Panels, l2Idx);
        return;
      }

      var l3Btn = e.target.closest("[data-cat-l3]");
      if (l3Btn) {
        var l3Scope =
          l3Btn.closest("[data-cat-l2-panel]") ||
          l3Btn.closest("[data-cat-l3-scope]");
        if (!l3Scope) return;
        var l3Idx = parseInt(l3Btn.dataset.l3Index, 10);
        var l3Buttons = l3Scope.querySelectorAll("[data-cat-l3]");
        var l3Panels = l3Scope.querySelectorAll("[data-cat-l3-panel]");
        setTabState(l3Buttons, l3Panels, l3Idx);
      }
    });

    if (modalClose) {
      modalClose.addEventListener("click", closePanel);
    }
    if (overlay) {
      overlay.addEventListener("click", closePanel);
    }

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && root.classList.contains("is-modal-open")) {
        closePanel();
      }
    });

    window.matchMedia(MOBILE_QUERY).addEventListener("change", function () {
      if (!panelOpen) return;
      var idx = activeL1;
      closePanel();
      openPanel(idx);
    });

  }

  function initAllCatNavi() {
    document.querySelectorAll("[data-cat-navi]").forEach(initCatNavi);
  }

  document.addEventListener("DOMContentLoaded", initAllCatNavi);
  document.addEventListener("shopify:section:load", initAllCatNavi);
})();

/* ============= Custom CartAdd Notification Modal (cart_type: modal) ============= */
(function () {
  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function renderAddedLineItem(container, lineItem, quantityLabel) {
    if (!container || !lineItem) return;

    var imageUrl = lineItem.featured_image?.url || lineItem.image || "";
    var imageAlt = lineItem.featured_image?.alt || lineItem.product_title || "";
    var propertiesHtml = "";

    if (lineItem.properties) {
      var propertyItems = [];
      Object.keys(lineItem.properties).forEach(function (key) {
        var value = lineItem.properties[key];
        if (!value || key.charAt(0) === "_") return;
        propertyItems.push("<li>" + escapeHtml(key) + ": " + escapeHtml(value) + "</li>");
      });
      if (propertyItems.length) {
        propertiesHtml =
          '<ul class="c-product-item-horizontal__item-properties list--unstyled text--subdued" role="list">' +
          propertyItems.join("") +
          "</ul>";
      }
    }

    var variantHtml = "";
    if (!lineItem.product_has_only_default_variant && lineItem.variant_title) {
      variantHtml =
        '<div class="c-product-item-horizontal__item-variant text--subdued">' +
        escapeHtml(lineItem.variant_title) +
        "</div>";
    }

    var imageHtml = imageUrl
      ? '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(imageAlt) + '" class="c-product-item-horizontal__item-image-element" loading="lazy" sizes="80px" width="80" height="80">'
      : "";

    container.innerHTML =
      '<div class="c-product-item-horizontal__item">' +
        '<a href="' + escapeHtml(lineItem.url || "#") + '" class="c-product-item-horizontal__item-image" tabindex="-1" aria-hidden="true">' +
          imageHtml +
        "</a>" +
        '<div class="c-product-item-horizontal__item-info">' +
          '<a href="' + escapeHtml(lineItem.url || "#") + '" class="c-product-item-horizontal__item-title">' +
            escapeHtml(lineItem.product_title || lineItem.title || "") +
          "</a>" +
          variantHtml +
          propertiesHtml +
          '<div class="c-product-item-horizontal__item-quantity text--subdued">' +
            escapeHtml(quantityLabel || "") +
            (quantityLabel ? ": " : "") +
            escapeHtml(lineItem.quantity) +
          "</div>" +
        "</div>" +
      "</div>";
  }

  function updateModalContent(modal, sectionHtml, addedLineItem) {
    if (sectionHtml) {
      var fakeDiv = document.createElement("div");
      fakeDiv.innerHTML = sectionHtml;
      var newModal = fakeDiv.querySelector("#custom-mini-cart");
      if (newModal) {
        modal.innerHTML = newModal.innerHTML;
      }
    }

    var itemContainer = modal.querySelector("[data-custom-mini-cart-item]");
    if (itemContainer && addedLineItem) {
      renderAddedLineItem(itemContainer, addedLineItem, modal.getAttribute("data-quantity-label"));
    }
  }

  function refreshCustomMiniCartModal(event) {
    if (window.themeVariables.settings.cartType !== "modal") return;
    if (!event.detail?.openCustomMiniCart) return;

    var modal = document.getElementById("custom-mini-cart");
    if (!modal) return;

    var sections = event.detail.sections || event.detail.cart?.sections;
    var sectionHtml = sections?.["custom-cart-add-notification"];
    updateModalContent(modal, sectionHtml, event.detail.addedLineItem);
    modal.open = true;
  }

  document.documentElement.addEventListener("cart:refresh", refreshCustomMiniCartModal);
})();


/* ============= Custom Drawer =============  */
(function() {
  'use strict';
  if (customElements.get('custom-drawer')) {
    return;
  }
  function getDrawerToggles(drawerId) {
    if (!drawerId) {
      return [];
    }
    return Array.from(document.querySelectorAll(`[aria-controls="${CSS.escape(drawerId)}"]`));
  }

  function shouldLockDrawer(toggles) {
    return toggles.some((toggle) => !toggle.classList.contains('c-drawer-toggle--nolock'));
  }

  class CustomDrawer extends HTMLElement {
    constructor() {
      super();
      this._listenersAttached = false;
      this._triggerToggle = null;
      this._originalPosition = null;
    }

    _shouldTeleportToBody() {
      return this.hasAttribute('data-teleport-to-body');
    }

    _saveOriginalPosition() {
      if (!this._originalPosition) {
        this._originalPosition = {
          parent: this.parentElement,
          nextSibling: this.nextSibling
        };
      }
    }

    _teleportToBody() {
      if (!this._shouldTeleportToBody()) {
        return;
      }
      this._saveOriginalPosition();
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
      }
    }

    _restoreFromBody() {
      if (!this._shouldTeleportToBody() || !this._originalPosition) {
        return;
      }
      const original = this._originalPosition;
      if (!original.parent) {
        return;
      }
      if (original.nextSibling && original.nextSibling.parentElement === original.parent) {
        original.parent.insertBefore(this, original.nextSibling);
      } else {
        original.parent.appendChild(this);
      }
    }
    connectedCallback() {
      if (this._listenersAttached) {
        return;
      }
      const overlay = this.querySelector('.drawer__overlay');
      const closeButton = this.querySelector('.drawer__close-button');     
      if (overlay) {
        overlay.addEventListener('click', () => {
          this.open = false;
        });
      }      
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          this.open = false;
        });
      }
      this._listenersAttached = true;
    }
    disconnectedCallback() {     
      this._listenersAttached = false;
    }
    static get observedAttributes() {
      return ['open'];
    }
    get open() {
      return this.hasAttribute('open');
    }
    set open(value) {
      if (value) {
        this.setAttribute('open', '');
      } else {
        this.removeAttribute('open');
      }
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue === newValue) {
        return;
      }

      if (name === 'open') {
        if (newValue !== null) {
          this._teleportToBody();
          const toggles = getDrawerToggles(this.id);
          if (toggles.length) {
            toggles.forEach((toggle) => {
              toggle.setAttribute('aria-expanded', 'true');
            });
            const lockToggles = this._triggerToggle ? [this._triggerToggle] : toggles;
            if (shouldLockDrawer(lockToggles) && !document.documentElement.classList.contains('lock-all')) {
              document.documentElement.classList.add('lock-all');
            }
          } else {
            const prevToggle = this.previousElementSibling;
            if (prevToggle && prevToggle.classList.contains('c-drawer-toggle')) {
              prevToggle.setAttribute('aria-expanded', 'true');
              if (shouldLockDrawer([prevToggle]) && !document.documentElement.classList.contains('lock-all')) {
                document.documentElement.classList.add('lock-all');
              }
            }
          }
          this.dispatchEvent(new CustomEvent('custom-drawer:open', {
            bubbles: true,
            detail: {
              drawer: this,
              trigger: this._triggerToggle
            }
          }));
        } else {
          const toggles = getDrawerToggles(this.id);
          if (toggles.length) {
            toggles.forEach((toggle) => {
              toggle.setAttribute('aria-expanded', 'false');
            });
          } else {
            const prevToggle = this.previousElementSibling;
            if (prevToggle && prevToggle.classList.contains('c-drawer-toggle')) {
              prevToggle.setAttribute('aria-expanded', 'false');
            }
          }
          this._triggerToggle = null;
          this._restoreFromBody();

          const otherOpenDrawers = document.querySelectorAll('custom-drawer[open]');
          let hasLockDrawer = false;
          otherOpenDrawers.forEach((drawer) => {
            if (drawer.id && shouldLockDrawer(getDrawerToggles(drawer.id))) {
              hasLockDrawer = true;
            }
          });

          if (!hasLockDrawer) {
            const themeDrawers = document.querySelectorAll('drawer-content[open]');
            if (themeDrawers.length === 0) {
              document.documentElement.classList.remove('lock-all');
            }
          }
          this.dispatchEvent(new CustomEvent('custom-drawer:close', {
            bubbles: true,
            detail: {
              drawer: this
            }
          }));
        }
      }
    }
  }

  customElements.define('custom-drawer', CustomDrawer);

  document.addEventListener('click', function (event) {
    let toggle = event.target.closest('.c-drawer-toggle');
    if (!toggle) {
      const candidate = event.target.closest('[aria-controls]');
      if (candidate) {
        const candidateDrawerId = candidate.getAttribute('aria-controls');
        const candidateDrawer = candidateDrawerId && document.getElementById(candidateDrawerId);
        if (candidateDrawer && candidateDrawer.tagName.toLowerCase() === 'custom-drawer') {
          toggle = candidate;
        }
      }
    }
    if (!toggle) {
      return;
    }

    if (toggle.getAttribute('is') === 'toggle-button' && !toggle.classList.contains('c-drawer-toggle')) {
      return;
    }

    let drawer = null;
    const drawerId = toggle.getAttribute('aria-controls');
    if (drawerId) {
      const target = document.getElementById(drawerId);
      if (target && target.tagName.toLowerCase() === 'custom-drawer') {
        drawer = target;
      }
    }
    if (!drawer && toggle.classList.contains('c-drawer-toggle')) {
      const sibling = toggle.nextElementSibling;
      if (sibling && sibling.tagName.toLowerCase() === 'custom-drawer') {
        drawer = sibling;
      }
    }
    if (!drawer) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    drawer._triggerToggle = toggle;
    drawer.open = !drawer.open;
  }, { passive: false });
})();


/* ============= Custom Modal ============= */
(function() {
  'use strict';

  function getModalToggles(modalId) {
    if (!modalId) {
      return [];
    }
    return Array.from(document.querySelectorAll(`[aria-controls="${CSS.escape(modalId)}"]`));
  }

  function syncModalToggleExpanded(modal, expanded) {
    if (!modal.id) {
      return;
    }
    getModalToggles(modal.id).forEach((toggle) => {
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  document.addEventListener('openable-element:open', function(event) {
    if (event.target.tagName.toLowerCase() !== 'modal-content' || !event.target.classList.contains('c-modal')) {
      return;
    }
    syncModalToggleExpanded(event.target, true);
  });

  document.addEventListener('openable-element:close', function(event) {
    if (event.target.tagName.toLowerCase() !== 'modal-content' || !event.target.classList.contains('c-modal')) {
      return;
    }
    syncModalToggleExpanded(event.target, false);
  });

  document.addEventListener('click', function(event) {
    let toggle = event.target.closest('.c-modal-toggle');
    if (!toggle) {
      const candidate = event.target.closest('[aria-controls]');
      if (candidate) {
        const candidateModalId = candidate.getAttribute('aria-controls');
        const candidateModal = candidateModalId && document.getElementById(candidateModalId);
        if (candidateModal && candidateModal.tagName.toLowerCase() === 'modal-content' && candidateModal.classList.contains('c-modal')) {
          toggle = candidate;
        }
      }
    }
    if (!toggle) {
      return;
    }

    if (toggle.getAttribute('is') === 'toggle-button' && !toggle.classList.contains('c-modal-toggle')) {
      return;
    }

    let modal = null;
    const modalId = toggle.getAttribute('aria-controls');
    if (modalId) {
      const target = document.getElementById(modalId);
      if (target && target.tagName.toLowerCase() === 'modal-content' && target.classList.contains('c-modal')) {
        modal = target;
      }
    }
    if (!modal && toggle.classList.contains('c-modal-toggle')) {
      const sibling = toggle.nextElementSibling;
      if (sibling && sibling.tagName.toLowerCase() === 'modal-content' && sibling.classList.contains('c-modal')) {
        modal = sibling;
      }
    }
    if (!modal) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    modal.open = !modal.open;
  }, { passive: false });
})();

/* ============= Visible Cart Count (exclude fee lines) ============= */
(function () {
  'use strict';

  var FEE_TITLE_KEY = '_legacy_product_as_fee_title';

  function getVisibleCartItemCount(cart) {
    if (!cart || !Array.isArray(cart.items)) {
      return cart && cart.item_count != null ? cart.item_count : 0;
    }

    return cart.items.reduce(function (total, item) {
      var props = item.properties || {};
      if (props[FEE_TITLE_KEY] != null) {
        return total;
      }
      return total + (Number(item.quantity) || 0);
    }, 0);
  }

  function syncCartCountElements(cart) {
    var count = getVisibleCartItemCount(cart);
    document.querySelectorAll('cart-count').forEach(function (el) {
      el.textContent = String(count);
    });
  }

  function scheduleSyncCartCount(cart) {
    queueMicrotask(function () {
      syncCartCountElements(cart);
    });
  }

  document.documentElement.addEventListener('cart:updated', function (event) {
    if (event.detail && event.detail.cart) {
      scheduleSyncCartCount(event.detail.cart);
    }
  });

  document.documentElement.addEventListener('cart:refresh', function (event) {
    if (event.detail && event.detail.cart) {
      scheduleSyncCartCount(event.detail.cart);
      return;
    }

    fetch('/cart.js', { cache: 'reload' })
      .then(function (response) {
        return response.json();
      })
      .then(syncCartCountElements)
      .catch(function () {});
  });

})();


/* ============= App Banner（iOS and Android detection） ============= */
(function () {
  var root = document.documentElement;
  if (root.classList.contains('is-ios') || root.classList.contains('is-android')) {
    return;
  }

  var ua = navigator.userAgent || '';
  var isIOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var isAndroid = /Android/i.test(ua);

  if (isIOS) {
    root.classList.add('is-ios');
  } else if (isAndroid) {
    root.classList.add('is-android');
  }
})();

/* ============= Mobile Menu (drill-down) ============= */
(function () {
  function showMobileMenuPanel(menu, panelId) {
    if (!menu || !panelId) return;

    menu.querySelectorAll('.c-mobile-menu-panel').forEach(function (panel) {
      var isActive = panel.getAttribute('data-panel-id') === panelId;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    menu.querySelectorAll('[data-mobile-menu-open]').forEach(function (btn) {
      btn.setAttribute(
        'aria-expanded',
        btn.getAttribute('data-mobile-menu-open') === panelId ? 'true' : 'false'
      );
    });

    menu.scrollTop = 0;
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-mobile-menu-open]');
    if (openBtn) {
      var openMenu = openBtn.closest('[data-mobile-menu]');
      if (!openMenu) return;
      e.preventDefault();
      showMobileMenuPanel(openMenu, openBtn.getAttribute('data-mobile-menu-open'));
      return;
    }

    var backBtn = e.target.closest('[data-mobile-menu-back]');
    if (!backBtn) return;

    var panel = backBtn.closest('.c-mobile-menu-panel');
    var backMenu = backBtn.closest('[data-mobile-menu]');
    if (!panel || !backMenu) return;

    e.preventDefault();
    showMobileMenuPanel(backMenu, panel.getAttribute('data-parent-panel') || 'root');
  });

  document.addEventListener('mobile-nav:close', function (e) {
    var menu = e.target.querySelector('[data-mobile-menu]');
    if (!menu) return;
    showMobileMenuPanel(menu, 'root');
  });
})();

/*================ Clipboard copy ================*/
document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-clipboard-copy]');
  if (!trigger) return;

  var text = trigger.getAttribute('data-clipboard-text');
  if (!text) return;

  navigator.clipboard.writeText(text);

  var message = trigger.getAttribute('data-clipboard-alert');
  if (message) {
    window.alert(message);
  }
});

/*================ Facet filter ================*/
(function () {
  function buildFacetFilterUrl(form) {
    var baseUrl = form.getAttribute('data-collection-url');
    if (!baseUrl) return '';

    var parts = [];
    form.querySelectorAll('[data-facet-filter-group]').forEach(function (group) {
      var key = group.getAttribute('data-param-key');
      if (!key) return;

      var values = [];
      group.querySelectorAll('input[type="checkbox"]:checked').forEach(function (input) {
        if (input.value) values.push(input.value);
      });

      if (values.length) {
        parts.push(
          encodeURIComponent(key) +
            '=' +
            values.map(function (value) {
              return encodeURIComponent(value);
            }).join(',')
        );
      }
    });

    if (!parts.length) return baseUrl;
    return baseUrl + (baseUrl.indexOf('?') === -1 ? '?' : '&') + parts.join('&');
  }

  function hasCheckedFacetFilter(form) {
    return Boolean(form.querySelector('input[type="checkbox"]:checked'));
  }

  function syncFacetFilterClearButton(form) {
    var clearButton = form.querySelector('[data-facet-filter-clear]');
    if (!clearButton) return;
    clearButton.disabled = !hasCheckedFacetFilter(form);
  }

  function syncFacetFilterFromUrl(form) {
    var params = new URLSearchParams(window.location.search);

    form.querySelectorAll('[data-facet-filter-group]').forEach(function (group) {
      var key = group.getAttribute('data-param-key');
      if (!key) return;

      var raw = params.get(key);
      var selected = raw
        ? raw.split(',').map(function (value) {
            return value.trim();
          }).filter(Boolean)
        : [];

      group.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
        input.checked = selected.indexOf(input.value) !== -1;
      });
    });
  }

  function initFacetFilter(root) {
    if (!root || root.getAttribute('data-facet-filter-ready') === 'true') return;

    var form = root.querySelector('[data-facet-filter-form]');
    if (!form) return;

    root.setAttribute('data-facet-filter-ready', 'true');
    syncFacetFilterFromUrl(form);
    syncFacetFilterClearButton(form);

    form.addEventListener('change', function (event) {
      if (!event.target.matches('input[type="checkbox"]')) return;
      syncFacetFilterClearButton(form);
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var url = buildFacetFilterUrl(form);
      if (!url) return;
      window.location.assign(url);
    });

    var clearButton = form.querySelector('[data-facet-filter-clear]');
    if (clearButton) {
      clearButton.addEventListener('click', function () {
        form.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
          input.checked = false;
        });
        syncFacetFilterClearButton(form);
      });
    }
  }

  function initAllFacetFilters(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-facet-filter]').forEach(initFacetFilter);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllFacetFilters();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllFacetFilters(event.target);
  });
})();

/* ============= Customer Tag Entry（顧客タグ付与: POST /apps/campaign/customer-tags） ============= */
(function () {
  var ENDPOINT = '/apps/campaign/customer-tags';
  var MESSAGES = {
    completed: '登録が完了しました。',
    failed: '登録に失敗しました。時間をおいて再度お試しください。'
  };

  function getConfig(root) {
    var script = root && root.querySelector('script[type="application/json"]');
    try {
      return JSON.parse(script.textContent) || {};
    } catch (error) {
      return {};
    }
  }

  function postTag(tag) {
    return fetch(ENDPOINT, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ tag: tag })
    })
      .then(function (response) {
        return response.json()
          .catch(function () {
            return null;
          })
          .then(function (json) {
            return { status: response.status, ok: response.ok && !!json && json.ok === true };
          });
      })
      .catch(function () {
        return { status: 0, ok: false };
      });
  }

  window.CustomCustomerTag = {
    post: postTag
  };

  function redirectToLogin(config) {
    var url = new URL(config.loginUrl || '/customer_authentication/login', window.location.origin);
    url.searchParams.set('return_to', window.location.pathname + window.location.search);
    window.location.href = url.pathname + url.search;
  }

  function showRegistered(root, button) {
    button.hidden = true;
    var message = root && root.querySelector('[data-customer-tag-registered]');
    if (message) message.hidden = false;
  }

  function complete(config, root, button) {
    if (config.completeAction === 'redirect' && config.redirectUrl) {
      window.location.href = config.redirectUrl;
      return;
    }
    window.alert(config.completeMessage || MESSAGES.completed);
    showRegistered(root, button);
  }

  function setBusy(button, busy) {
    button.disabled = busy;
    if (busy) {
      button.setAttribute('aria-busy', 'true');
    } else {
      button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-customer-tag-button]');
    if (!button || button.disabled) return;

    var root = button.closest('[data-customer-tag-entry]');
    var config = getConfig(root);

    if (config.loggedIn === false) {
      redirectToLogin(config);
      return;
    }

    setBusy(button, true);

    postTag(String(config.tag || '').trim()).then(function (result) {
      setBusy(button, false);

      if (result.ok) {
        complete(config, root, button);
        return;
      }
      if (result.status === 401) {
        redirectToLogin(config);
        return;
      }
      window.alert(MESSAGES.failed);
    });
  });
})();
